import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface BulkTransferState {
  staticData: any[]
}

const initialState: BulkTransferState = {
  staticData: []
}

const bulkTransferSlice = createSlice({
  name: 'bulkTransfer',
  initialState,
  reducers: {
    setStaticData: (state, action: PayloadAction<any[]>) => {
      state.staticData = action.payload
    },
    clearStaticData: (state) => {
      state.staticData = []
    }
  }
})

export const { setStaticData, clearStaticData } = bulkTransferSlice.actions
export default bulkTransferSlice.reducer